import Shimmer from "@/components/Shimmer";
import useIsMobile from "@/utils/useIsMobile";

const HealthCheckLoading = () => {
  const isMobile = useIsMobile();
  const renderSingleOptInLoading = () => (
    <div className="ml-10 mt-15">
      <Shimmer width="100%" height="75px" rounded="sm" />
      <div className="mt-20">
        <div className="flex flex-grow flex-col items-center gap-30 p-10 md:flex-row md:gap-[95px]">
          <div className="ml-auto mr-auto md:ml-[110px] md:mr-[unset]">
            <Shimmer
              height={isMobile ? "400px" : "836px"}
              width={isMobile ? "200px" : "440px"}
              rounded="lg"
            />
          </div>

          <div className="flex flex-grow flex-col">
            <Shimmer width="40%" height="30px" rounded="sm" />
            <Shimmer width="100%" height="225px" rounded="sm" />
            <div className="mt-20">
              <Shimmer width="50%" height="30px" rounded="sm" />
            </div>
            <div className="mt-10 md:mt-30 *:[&>*:first-child]:mt-[unset]">
              <Shimmer width="40%" height="30px" rounded="sm" />
            </div>
            <div className="mt-10">
              <Shimmer width="50%" height="30px" rounded="sm" />
            </div>
            <div className="mt-20">
              <Shimmer width="40%" height="30px" rounded="sm" />
            </div>
            <div className="mt-10">
              <Shimmer width="60%" height="30px" rounded="sm" />
            </div>

            <div className="mt-10 md:mt-30 *:[&>*:first-child]:mt-[unset]">
              <Shimmer width="40%" height="30px" rounded="sm" />
            </div>
            <div className="mt-10">
              <Shimmer width="50%" height="30px" rounded="sm" />
            </div>
            <div className="mt-20">
              <Shimmer width="40%" height="30px" rounded="sm" />
            </div>
            <div className="mt-10">
              <Shimmer width="60%" height="30px" rounded="sm" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderDoubleOptInLoading = () => (
    <div className="lm-10 mt-15">
      <Shimmer width="100%" height="75px" rounded="sm" />
      <div className="mt-20">
        <div className="flex flex-grow flex-col items-center gap-30 p-10 md:flex-row md:gap-[95px]">
          <div className="ml-auto mr-auto md:ml-[110px] md:mr-[unset]">
            <Shimmer
              height={isMobile ? "400px" : "836px"}
              width={isMobile ? "200px" : "440px"}
              rounded="lg"
            />
          </div>

          <div className="flex flex-grow flex-col">
            <Shimmer width="50%" height="30px" rounded="sm" />
            <Shimmer width="100%" height="90px" rounded="sm" />
            <div className="mt-20">
              <Shimmer width="50%" height="30px" rounded="sm" />
            </div>
            <div className="mt-10 md:mt-30 *:[&>*:first-child]:mt-[unset]">
              <Shimmer width="20%" height="30px" rounded="sm" />
            </div>
            <div className="mt-10">
              <Shimmer width="70%" height="40px" rounded="sm" />
            </div>
            <div className="mt-20">
              <Shimmer width="40%" height="30px" rounded="sm" />
            </div>

            <div className="mt-10 md:mt-30 *:[&>*:first-child]:mt-[unset]">
              <Shimmer width="40%" height="30px" rounded="sm" />
            </div>
            <div className="mt-10">
              <Shimmer width="340px" height="228px" rounded="sm" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {renderSingleOptInLoading()}
      {renderDoubleOptInLoading()}
    </>
  );
};

export default HealthCheckLoading;
